export default "__VITE_ASSET__q8rnR_d2__"